(function ($) { 

  Drupal.behaviors.homeTeaserArtistResidency = {
	    attach: function (context) {
	    		Drupal.behaviors.homeTeaserArtistResidencyCreator(context)
	    }
  };

  Drupal.behaviors.homeTeaserArtistResidencyCreator = function (context){

	$(".homeTeaserArtistResidency", context).each(function (index){    			
		var mainContent = $(this);
		var footerNavText = $(mainContent).data("footer-nav");
		var images = $(mainContent).data("images");
		//var imageAlt = $(mainContent).data("image-alt");
		
		
		var isAlreadyModified = $(mainContent).data("saph-done");
		if(isAlreadyModified){
			return true;
		}
		$(mainContent).height($(window).height());
		Drupal.behaviors.linkButtonCreator($(mainContent));

  		$(".homeTeaserMain",mainContent).addClass("main-content-offset fullHeight position-relative");
  		$(".homeTeaserTextMain",mainContent).addClass("fullHeight");
  		$(".homeTeaserImageWrapper",mainContent).addClass("row fullHeight fullWidth");
  		
  		$(".homeTeaserImageWrapper",mainContent).append('<div class="homeTeaserMainImageMask position-relative fullHeight">\
			<div class="homeTeaserArtistResidencyImagesArea  position-absolute margin-auto"></div></div>');
		$.each(images, function(index){
			$(".homeTeaserArtistResidencyImagesArea",mainContent).append('\
					<div class="homeTeaserArtistResidencyImageRect' + (index + 1) + ' homeTeaserArtistResidencyImage" style="background-image:url(' + images[index].imagePath + ')"></div>');
			
			$(mainContent).append('<div class="animatedImage' + (index + 1) + '  homeTeaserArtistResidencyAnimatedImage reveal-animate" style="\
					background-image:url(' + images[index].imagePath + ');\
			"></div>');

		})
  		
		Drupal.behaviors.calcHomeTeaserArtistResidency(mainContent);
		  
		//And Everytime the user resizes the window
		$(window).resize(function() {
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserArtistResidency(mainContent);
		});
		$(mainContent).addClass("overflow-hidden");
		/*
		$(mainContent).data("animation-type","AboveToCenter");
		Drupal.behaviors.homeTeaserArtistResidencyScroll();
		*/
		$(mainContent).data("saph-done",true);	    

		$(mainContent).ready(function(){
			//Drupal.behaviors.functions.initOnScreenAnimations(".homeTeaserArtistResidency");
		});		
		
  	});
  }
  
	Drupal.behaviors.calcHomeTeaserArtistResidency = function (mainContent) {
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionTop;
		var bottomPositionLimit;
		var saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();//$(".saphNavHeader").first().height();
		var imageSectionWidth = $(".homeTeaserMainImageMask",mainContent).width();
		var imageCol1Width = $(".homeTeaserArtistResidencyImageCol2",mainContent).width();
		var imageHeightOffset = 70;
		var textPortraitBottomOffset = 70;
		Drupal.behaviors.functions.consolog("Drupal.behaviors.calcHomeTeaserArtistResidency()");

		//$(".homeTeaserArtistResidencyTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
		//textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
		
		$(".homeTeaserArtistResidencyImagesArea",mainContent).css("top",0);
		$(".homeTeaserArtistResidencyImagesArea",mainContent).css("bottom",0);
		$(".homeTeaserArtistResidencyImagesArea",mainContent).css("left",0);
		$(".homeTeaserArtistResidencyImagesArea",mainContent).css("right",0);
		
		var actualHeight;
		
		if(Drupal.behaviors.isPortraitMode()){
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h3");
				$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h2");
				
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("text-class","h2");			
				
				$(".homeTeaserArtistResidencyHeadline span",mainContent).addClass("h2");
				$(".homeTeaserArtistResidencyHeadline span",mainContent).removeClass("h1-hero");
			}else{
				$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h2");
				$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h3");

				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("text-class","h1-hero");		
				
				$(".homeTeaserArtistResidencyHeadline span",mainContent).removeClass("h2");
				$(".homeTeaserArtistResidencyHeadline span",mainContent).addClass("h1-hero");
			}
			if($(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).length){
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-6 col-xs-offset-6");
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-12");
			
			$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("col-xs-12");
			$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("col-xs-5");
			
			$(".homeTeaserArtistResidencyHeadline",mainContent).addClass("col-xs-12");
			$(".homeTeaserArtistResidencyHeadline",mainContent).removeClass("col-xs-6");
			
			$(".homeTeaserArtistResidencyCopyText",mainContent).addClass("col-xs-12");
			$(".homeTeaserArtistResidencyCopyText",mainContent).removeClass("col-xs-6");
			
			textSectionHeight = $(".homeTeaserArtistResidencyTextSection",mainContent).height();	
			$(".homeTeaserArtistResidencyTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
			
			actualHeight = textSectionTop-saphNavHeaderHeight-20;
			
		}else{
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h3");
				$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h2");
				
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("is-small",true);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("text-class","h2");					

				$(".homeTeaserArtistResidencyHeadline span",mainContent).addClass("h2");
				$(".homeTeaserArtistResidencyHeadline span",mainContent).removeClass("h1-hero");
			}else{
				$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h2");
				$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h3");
				
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("is-small",false);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("text-class","h1-hero");									

				$(".homeTeaserArtistResidencyHeadline span",mainContent).removeClass("h2");
				$(".homeTeaserArtistResidencyHeadline span",mainContent).addClass("h1-hero");				
			}
			if($(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).length){
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).data("saph-done",false);
				$(".homeTeaserArtistResidencyHeadline .linkButton",mainContent).empty();
				Drupal.behaviors.linkButtonCreator(mainContent);
			}
			
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-6 col-xs-offset-6");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-12");
			
			$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("col-xs-12");
			$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("col-xs-5");
			
			$(".homeTeaserArtistResidencyHeadline",mainContent).removeClass("col-xs-12");
			$(".homeTeaserArtistResidencyHeadline",mainContent).addClass("col-xs-6");
			
			$(".homeTeaserArtistResidencyCopyText",mainContent).removeClass("col-xs-12");
			$(".homeTeaserArtistResidencyCopyText",mainContent).addClass("col-xs-6");
			
			textSectionHeight = $(".homeTeaserArtistResidencyTextSection",mainContent).height();	
			$(".homeTeaserArtistResidencyTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-imageHeightOffset;
		}		
		//actualHeight = fullHeight-saphNavHeaderHeight-30;
		/*
		var actualHeight;
		if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
			$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h3-no-change");
			textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
			actualHeight = textSectionTop-saphNavHeaderHeight-30-15;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);			
		}else if(Drupal.behaviors.globalVariables.currentMediaType == "Something Else"){
			$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h1");
			textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
			actualHeight = textSectionTop-saphNavHeaderHeight-30-30-15;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}else{
			$(".homeTeaserArtistResidencySubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserArtistResidencySubHeadline",mainContent).addClass("h1");
			textSectionTop = $(".homeTeaserArtistResidencyTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-30-120;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}
		*/
		$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		//homeTeaserArtistResidencyImageRect
		$(".homeTeaserMainImageMask",mainContent).css("top",saphNavHeaderHeight);
		//$(".homeTeaserArtistResidencyImagesArea",mainContent).css("bottom",imageHeightOffset);
		
		//Default size
		/*
		 * Window
		 * width 1005
		 * height 888
		 */
		
		var ratioW = $(".homeTeaserMainImageMask",mainContent).width()/553;
		var ratioH = actualHeight/619;
		var actualRatio = ratioH;
		if(ratioW<ratioH){
			actualRatio = ratioW;
		}

		$(".homeTeaserArtistResidencyImageRect1",mainContent).css("left",136*actualRatio);
		$(".homeTeaserArtistResidencyImageRect1",mainContent).css("top",0*actualRatio);
		$(".homeTeaserArtistResidencyImageRect1",mainContent).css("width",417*actualRatio);
		$(".homeTeaserArtistResidencyImageRect1",mainContent).css("height",555*actualRatio);

		$(".homeTeaserArtistResidencyImageRect2",mainContent).css("left",0*actualRatio);
		$(".homeTeaserArtistResidencyImageRect2",mainContent).css("top",270*actualRatio);
		$(".homeTeaserArtistResidencyImageRect2",mainContent).css("width",525*actualRatio);
		$(".homeTeaserArtistResidencyImageRect2",mainContent).css("height",349*actualRatio);
		
		$(".homeTeaserArtistResidencyImagesArea",mainContent).width((136*actualRatio) + (417*actualRatio));
		$(".homeTeaserArtistResidencyImagesArea",mainContent).height((270*actualRatio) + (349*actualRatio));
		
		//Setup the animatedImages pos and size
		var images = $(mainContent).data("images");
		var positionOfMainContainer = $(mainContent).offset();
		
		$.each(images, function(index){
			$(".animatedImage" + (index + 1),mainContent).css("left", $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent).offset().left -positionOfMainContainer.left);
			$(".animatedImage" + (index + 1),mainContent).css("top", $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent).offset().top - positionOfMainContainer.top);
			$(".animatedImage" + (index + 1),mainContent).width($(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent).width());
			$(".animatedImage" + (index + 1),mainContent).height($(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent).height());
			$(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent).addClass("dissappearElement");
		});
		
		$(mainContent).append($(".homeTeaserMain",mainContent));
	};  
  
  
	Drupal.behaviors.changeHomeTeaserArtistResidencyMode = function () {
		$(".homeTeaserArtistResidency").each(function (index){
			var mainContent = $(this);
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserArtistResidency(mainContent);
    		});
	};
	
	Drupal.behaviors.animateHomeTeaserArtistResidencyAboveToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();
			
			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserArtistResidencyAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
						top: -$(animatedImageElement).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.
						  });
					  });
			});
    		//});
	};
	Drupal.behaviors.animateHomeTeaserArtistResidencyCenterToAbove = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserArtistResidencyAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: -$(animatedImageElement).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	
	
	Drupal.behaviors.animateHomeTeaserArtistResidencyBelowToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserArtistResidencyAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
						top: $(mainContent).height(),//$(animatedImageElement).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.animateHomeTeaserArtistResidencyCenterToBelow = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserArtistResidencyAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserArtistResidencyImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(mainContent).height(),//$(animatedImageElement).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.
							  
						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.homeTeaserArtistResidencyScroll = function () {
		return true; //No animations for now
		var lastScrollTop = 0, delta = 5;
		$(window).scroll(function() {
			var elmentScrollPoint;
			var scrollTop = $(this).scrollTop();
			var scrollBottom = scrollTop + $(window).height();

			$(".homeTeaserArtistResidency").each(function (index){
				//Get center position
				var mainContent = $(this);
				var elementHeight = $(mainContent).height();
				var scrollPositionOfElement = $(mainContent).offset().top;
				var elementCenterPosition = scrollPositionOfElement + (elementHeight/2);
				var elementEndPosition = scrollPositionOfElement + elementHeight;
				
				if(Math.abs(lastScrollTop - scrollTop) <= delta){
					return true;
				}
			    var isDownDir;
				if (scrollTop > lastScrollTop){
					//downscroll code
					isDownDir = true;
				} else {
					//upscroll code
					isDownDir = false;
				}
				
				
				if(!isDownDir && scrollTop < elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserArtistResidencyAboveToCenter(mainContent);
					$(mainContent).data("animation-type","AboveToCenter");				
				}else if (isDownDir && scrollTop > elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserArtistResidencyCenterToAbove(mainContent);
					$(mainContent).data("animation-type","CenterToAbove");					
				}else if (isDownDir && scrollBottom > elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserArtistResidencyBelowToCenter(mainContent);
					$(mainContent).data("animation-type","BelowToCenter");
				}else if (!isDownDir && scrollBottom < elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserArtistResidencyCenterToBelow(mainContent);
					$(mainContent).data("animation-type","CenterToBelow");
				}
			});
			lastScrollTop = scrollTop;
		});
	};

})(jQuery);